import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import * as Urls from '../../constants/Urls';

const getBasePathname = (path) => {
  switch (path) {
    case Urls.NEW_WORKFLOW_STEP:
      return Urls.WORKFLOW_STEP;

    case Urls.NEW_ENTITY_DISPLAY:
      return Urls.ENTITY_DISPLAY;

    case Urls.NEW_MASTER_SETUP_PAGE:
      return Urls.MASTER_SETUP_PAGE;

    default:
      return Urls.HOME;
  }
};

const RuntimeRedirectRoute = ({ path }) => (
  <Route
    path={path}
    component={({ location }) => (
      <Redirect
        to={{
          ...location,
          pathname: getBasePathname(path),
        }}
      />
    )}
  />
);

export default RuntimeRedirectRoute;
